import React from 'react';
import { MenuGroup } from '@atlaskit/menu';
import { MENU_ID_CUSTOMERS } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useConfigurableMessageAndIconMap } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { HideL1MenuItemSection } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { MoreNavMenuButton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { generatePath } from '@atlassian/react-resource-router';
import { customerServiceCustomersRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceCustomersRoute.tsx';
import { getMenuItemAnalytics } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const MenuItems = () => (
	<MenuGroup>
		<HideL1MenuItemSection menuId={MENU_ID_CUSTOMERS} hasSeparator={false} />
	</MenuGroup>
);

export const CustomersMenuLinkItem = (): React.JSX.Element => {
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(MENU_ID_CUSTOMERS);

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_CUSTOMERS],
		itemId: 'customers',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			testId="navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers"
			href={generatePath(customerServiceCustomersRoute.path)}
			menuId={MENU_ID_CUSTOMERS}
			elemBefore={icon}
			actionsOnHover={<MoreNavMenuButton MenuItems={MenuItems} />}
			analytics={fg('csm-onboarding') ? analytics : undefined}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
};
